import React, { useEffect, useState, useRef } from "react"
import { useParams } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  FormGroup,
} from "reactstrap"
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined"
import axios from "axios"
import * as Yup from "yup"
import { useFormik } from "formik"
import { createSelector } from "reselect"
import { loginUser, setBreadcrumbItems } from "../../store/actions"
import { useSelector, useDispatch } from "react-redux"
import ConfirmationModal from "newcomponents/confirmation-modal"
import {
  EmailOutlined,
  BusinessOutlined,
  PhoneOutlined,
  LocationOnOutlined,
} from "@mui/icons-material"
import { Switch } from "@mui/material"
import {
  updateOrganizationRequest,
  resetOrgFlag,
} from "../../store/Organization/actions"
import config from "../../config/config"
import PropTypes from "prop-types"
import { Spinner } from "reactstrap"
import SnackbarComponent from "components/SnackBar"
import OrganizationPlaceId from "components/GooglePlaceIdComponent/GooglePlaceIdComponent"
import PrimaryButton from "newcomponents/primary-button"

const OrganizationForm = props => {
  document.title = "Organization | Reputation Management"

  const dispatch = useDispatch()

  const breadcrumbItems = [
    { title: "Organizations", link: "/organizations-list" },
    { title: "Organization Form", link: "#" },
  ]

  useEffect(() => {
    dispatch(setBreadcrumbItems("Organizations", breadcrumbItems))
  }, [])
  const organizations = useSelector(
    state => state.organizationReducer.organizations,
  )
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const userData = useSelector(state => state.Login.userData)
  const [confirmModalOpen, setConfirmModalOpen] = useState(false)
  const mode = useSelector(state => state.Layout.layoutMode)
  const { id } = useParams()
  const [visible, setVisible] = useState(true)
  const [organization, setOrganization] = useState({})
  const fileInputRef = useRef(null)
  const onDismiss = () => setVisible(false)
  const [loading, setLoading] = useState(false)
  const [countries, setCountries] = useState([])
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])
  const [countryCode, setCountryCode] = useState("")
  const [stateCode, setStateCode] = useState("")
  const [alertPrefs, setAlertPrefs] = useState({
    individualResponse: false,
    summary: false,
    inactivity: false,
    campaignOpen: false,
  })

  const fetchCountries = async () => {
    try {
      setLoading(true)
      const response = await axios.get(
        "https://api.countrystatecity.in/v1/countries",
        {
          headers: {
            "X-CSCAPI-KEY":
              "VElGVWJxblkwQWlaTlVtUVRTZTlKSHRvSnJhZDBKenVBS2l0am5hdw==",
          },
        },
      )
      const transformedArray = response.data.map(country => ({
        id: country.id,
        label: country.name,
        value: country.name,
        code: country.iso2,
      }))
      setCountries(transformedArray)
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }
  const fetchStates = async code => {
    try {
      setLoading(true)
      const response = await axios.get(
        `https://api.countrystatecity.in/v1/countries/${code}/states`,
        {
          headers: {
            "X-CSCAPI-KEY":
              "VElGVWJxblkwQWlaTlVtUVRTZTlKSHRvSnJhZDBKenVBS2l0am5hdw==",
          },
        },
      )
      const transformedArray = response.data.map(state => ({
        id: state.id,
        label: state.name,
        value: state.name,
        code: state.iso2,
      }))
      setStates(transformedArray)
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const fetchCities = async (ccode, scode) => {
    try {
      setLoading(true)
      const response = await axios.get(
        `https://api.countrystatecity.in/v1/countries/${ccode}/states/${scode}/cities`,
        {
          headers: {
            "X-CSCAPI-KEY":
              "VElGVWJxblkwQWlaTlVtUVRTZTlKSHRvSnJhZDBKenVBS2l0am5hdw==",
          },
        },
      )
      const transformedArray = response.data.map(city => ({
        id: city.id,
        label: city.name,
        value: city.name,
      }))
      setCities(transformedArray)
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const selectOrganizationState = state => state.organizationReducer
  const OrganizationProperties = createSelector(
    selectOrganizationState,
    organization => ({
      error: organization.error,
      success: organization.success,
    }),
  )

  const { error, success } = useSelector(OrganizationProperties)

  const fetchOrganization = async () => {
    setLoading(true)
    console.log("Organizations", organizations)
    const found = organizations.find(org => org.Organization.id == id)

    console.log("FOund: ", found)

    setOrganization(found.Organization)
    setLoading(false)
  }

  useEffect(() => {
    fetchOrganization()
    fetchCountries()
  }, [id, organizations])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: organization.id || 0,
      name: organization.name || "",
      email: organization.email || "",
      address: organization.address || "",
      city: organization.city || "",
      state: organization.state || "",
      country: organization.country || "",
      contact: organization.contact || "",
      description: organization.description || "",
      website: organization.website || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Organization Name"),
      email: Yup.string()
        .email("Invalid Email")
        .required("Please Enter Organization Email"),
      address: Yup.string().required("Please Enter Organization Address"),
      city: Yup.string().required("Please Enter City"),
      state: Yup.string().required("Please Enter State"),
      country: Yup.string().required("Please Enter Country"),
      contact: Yup.string().required("Please Enter Contact Number"),
      description: Yup.string().required("Please Enter Description"),
      website: Yup.string().url("Invalid URL").required("Please Enter Website"),
    }),
    onSubmit: async values => {
      setLoading(true)
      const updatedData = {}

      Object.keys(values).forEach(key => {
        if (values[key] !== validation.initialValues[key]) {
          updatedData[key] = values[key]
        }
      })
      updatedData.organizationId = organization.id

      // Append logo if changed
      if (avatarFile) updatedData.logo = avatarFile

      console.log("Updated Company: ", updatedData)

      dispatch(updateOrganizationRequest(updatedData))
      setAvatarFile(null)
      setLoading(false)
      dispatch(loginUser(updatedData, props.router.navigate))
    },
  })

  // Fix for MUI Switch onChange signature
  const handleToggle = event => {
    const { name, checked } = event.target
    console.log("Switch toggled:", name, checked)
    setAlertPrefs(prev => ({ ...prev, [name]: checked }))
  }

  const saveAlertPrefs = async () => {
    console.log("Saving alert preferences", alertPrefs)
    setLoading(true)
    // Get audienceDataToSend from somewhere (adjust as needed)
    const audienceDataToSend = organization.audience || null

    console.log("YUSerData", userData)

    await axios
      .put(
        `${config.backendUrl}/organization/updateOrganizaionAlertPreferences`,
        {
          organizationId: organization.id,
          individualResponse: alertPrefs.individualResponse,
          summary: alertPrefs.summary,
          inactivity: alertPrefs.inactivity,
          campaignOpen: alertPrefs.campaignOpen,
        },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
      .then(res => {
        console.log("Alert preferences saved successfully", res.data)
        dispatch(
          updateOrganizationRequest({
            organizationId: organization.id,
            ...activeOrganization,
          }),
        )
        setTimeout(() => {
          setLoading(false)
        }, 1000)
      })
      .catch(err => {
        console.error("Error saving alert preferences", err)
        setLoading(false)
      })
  }

  useEffect(() => {
    if (success) {
      // Show Snackbar for success
      setTimeout(() => {
        dispatch(resetOrgFlag())
      }, 3000)
    }
    if (error) {
      // Show Snackbar for error
      setTimeout(() => {
        dispatch(resetOrgFlag())
      }, 3000)
    }
  }, [dispatch, success, error])

  useEffect(() => {
    if (countries.length > 0) {
      const selectedCountry = countries.find(
        country => country.value === validation.values.country,
      )

      fetchStates(selectedCountry?.code)
    }
  }, [countries])
  useEffect(() => {
    if (states.length > 0 && validation.values.state.length > 1) {
      console.log("STate", states)
      console.log("here")
      const selectedCountry = countries.find(
        country => country.value === validation.values.country,
      )
      const selectedState = states.find(
        state => state.value === validation.values.state,
      )

      fetchCities(selectedCountry?.code, selectedState?.code)
    }
  }, [states])

  const [avatarPreview, setAvatarPreview] = useState(
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvzjs9Wl8YK3J8ZNb-1irAd3odihFLn9mxnA&s",
  )

  useEffect(() => {
    if (organization.logo) {
      setAvatarPreview(organization.logo)
    }
  }, [organization.logo])

  const [avatarFile, setAvatarFile] = useState(null)

  function dataURItoBlob(dataURI) {
    setLoading(true)
    let formData = new FormData()
    formData.append("file", dataURI)
    // setloading(true)
    axios
      .post(
        `${config.backendUrl}/aws/file?email=reputation-management`,
        formData,
      )
      .then(res => {
        const uploadedUrl = res.data.url
        setAvatarFile(uploadedUrl)
        console.log("avatar", avatarFile)
        setAvatarPreview(uploadedUrl)

        setLoading(false)
        // console.log(res)
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
      })
  }

  const [checked, setChecked] = React.useState(true)

  const handleChange = event => {
    setChecked(event.target.checked)
  }

  const handleCountryChange = e => {
    const selectedCountry = countries.find(
      country => country.value === e.target.value,
    )

    if (selectedCountry) {
      setCountryCode(selectedCountry.code)
      fetchStates(selectedCountry?.code)

      // Reset the state and city values
      validation.setFieldValue("state", "")
      validation.setFieldValue("city", "")
    }
  }
  const handleStateChange = e => {
    console.log(e.target.value)
    const selectedCountry = countries.find(
      country => country.value === validation.values.country,
    )
    const selectedState = states.find(state => state.value === e.target.value)
    if (selectedState) {
      setStateCode(selectedCountry?.code)
      fetchCities(selectedCountry?.code, selectedState?.code) // Updated to use the selected country code
    }
  }

  useEffect(() => {
    if (organization) {
      if (organization.OrganizationAlertPreference) {
        console.log(
          "Organization Alert Preferences",
          organization.OrganizationAlertPreference,
        )
        setAlertPrefs({
          individualResponse:
            organization.OrganizationAlertPreference.individualResponses,
          summary: organization.OrganizationAlertPreference.summary,
          inactivity: organization.OrganizationAlertPreference.inactivity,
          campaignOpen: organization.OrganizationAlertPreference.campaignOpen,
        })
      }
    }
  }, [organization])
  return (
    <React.Fragment>
      <SnackbarComponent err={error} success={success} />
      <div
        style={{
          borderRadius: "20px",
        }}
      >
        <Container
          style={{
            padding: "0px",
          }}
          fluid
        >
          <Row>
            <Col lg="14">
              <Card
                style={{
                  borderRadius: "20px",
                }}
              >
                <CardBody>
                  <div className="d-flex" style={{ gap: "20px" }}>
                    <div className="ms-3">
                      <img
                        src={avatarPreview || organization.logo}
                        alt=""
                        style={{
                          objectFit: "cover",
                          width: "80px",
                          height: "80px",
                        }}
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <p className="mb-0">Id no: #{organization.id}</p>
                        <h5>
                          {organization.name} ({organization.type})
                        </h5>
                        <p className="mb-1">
                          {organization.address} - {organization.city} -{" "}
                          {organization.country}
                        </p>
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        id="avatarInput"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={e => dataURItoBlob(e.target.files[0])}
                      />

                      {/* Styled PrimaryButton */}
                      <PrimaryButton
                        style={{
                          height: "35px",
                          alignSelf: "center",
                          backgroundColor: mode === "dark" ? "#fff" : "#2990DF",
                          padding: "0px 10px",
                          borderRadius: "5px",
                          fontSize: "14px",
                          marginRight: "4px",
                          color: mode === "dark" ? "#000" : "#fff",
                          cursor: "pointer",
                        }}
                        type="button"
                        onClick={() =>
                          document.getElementById("avatarInput").click()
                        }
                      >
                        Change Avatar
                      </PrimaryButton>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <div
            style={{
              borderRadius: "20px",
              background: mode === "dark" ? "#252F40" : "#fff",
              boxShadow:
                mode === "dark"
                  ? "0px 4px 12px rgba(0, 0, 0, 0.1)"
                  : "0px 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h4
              style={{
                paddingTop: "15px",
                marginLeft: "10px",
                color: mode === "dark" ? "#fff" : "#000",
              }}
              className="card-title mb-4"
            >
              Update Organization
            </h4>

            <Card
              style={{
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
                boxShadow: "none",
              }}
            >
              <CardBody>
                <Form
                  className="form-horizontal"
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <Label
                          style={{
                            color: mode === "dark" ? "#fff" : "#000",
                          }}
                          className="form-label mt-2"
                        >
                          Organization Name
                        </Label>
                        <div style={{ position: "relative", height: "45px" }}>
                          <BusinessOutlined
                            style={{
                              position: "absolute",
                              left: "10px",
                              top: "40%",
                              transform: "translateY(-50%)",
                              color: mode === "dark" ? "#fff" : "#6c757d",
                              fontSize: "20px",
                            }}
                          />
                          <Input
                            name="name"
                            style={{ paddingLeft: "38px" }}
                            className="form-control"
                            placeholder="Enter Organization Name"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name
                            }
                          />
                        </div>
                        {validation.touched.name && validation.errors.name && (
                          <FormFeedback type="invalid">
                            {validation.errors.name}
                          </FormFeedback>
                        )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <Label
                          style={{
                            color: mode === "dark" ? "#fff" : "#000",
                          }}
                          className="form-label mt-2"
                        >
                          Email
                        </Label>
                        <div style={{ position: "relative", height: "45px" }}>
                          <EmailOutlined
                            style={{
                              position: "absolute",
                              left: "10px",
                              top: "40%",
                              transform: "translateY(-50%)",
                              color: mode === "dark" ? "#fff" : "#6c757d",

                              fontSize: "20px",
                            }}
                          />
                          <Input
                            name="email"
                            style={{ paddingLeft: "38px" }}
                            className="form-control"
                            placeholder="Enter Organization Email"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                            }
                          />
                        </div>
                        {validation.touched.email &&
                          validation.errors.email && (
                            <FormFeedback type="invalid">
                              {validation.errors.email}
                            </FormFeedback>
                          )}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <Label
                          style={{
                            color: mode === "dark" ? "#fff" : "#000",
                          }}
                          className="form-label mt-2"
                        >
                          Address
                        </Label>
                        <div style={{ position: "relative", height: "45px" }}>
                          <LocationOnOutlined
                            style={{
                              position: "absolute",
                              left: "10px",
                              top: "40%",
                              transform: "translateY(-50%)",
                              fontSize: "20px",
                              color: mode === "dark" ? "#fff" : "#6c757d",
                            }}
                          />
                          <Input
                            name="address"
                            style={{ paddingLeft: "38px" }}
                            className="form-control"
                            placeholder="Enter Address"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.address || ""}
                            invalid={
                              validation.touched.address &&
                              validation.errors.address
                            }
                          />
                        </div>
                        {validation.touched.address &&
                          validation.errors.address && (
                            <FormFeedback type="invalid">
                              {validation.errors.address}
                            </FormFeedback>
                          )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div
                        style={{
                          color: mode === "dark" ? "#fff" : "#000",
                        }}
                        className="form-group"
                      >
                        <Label className="form-label mt-2">
                          Contact Number
                        </Label>
                        <div style={{ position: "relative", height: "45px" }}>
                          <PhoneOutlined
                            style={{
                              position: "absolute",
                              left: "10px",
                              top: "40%",
                              transform: "translateY(-50%)",
                              color: mode === "dark" ? "#fff" : "#6c757d",
                              fontSize: "20px",
                            }}
                          />
                          <Input
                            name="contact"
                            style={{ paddingLeft: "38px" }}
                            className="form-control"
                            placeholder="Enter Contact Number"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.contact || ""}
                            invalid={
                              validation.touched.contact &&
                              validation.errors.contact
                            }
                          />
                        </div>
                        {validation.touched.contact &&
                          validation.errors.contact && (
                            <FormFeedback type="invalid">
                              {validation.errors.contact}
                            </FormFeedback>
                          )}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <Label
                          style={{
                            color: mode === "dark" ? "#fff" : "#000",
                          }}
                          className="form-label mt-2"
                        >
                          City
                        </Label>
                        <Input
                          name="city"
                          className="form-control"
                          placeholder="Enter City"
                          type="select"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.city || ""}
                          invalid={
                            validation.touched.city && validation.errors.city
                          }
                        >
                          <option>Select City</option>
                          {cities.map(city => (
                            <option key={city.id} value={city.value}>
                              {city.label}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.city && validation.errors.city && (
                          <FormFeedback type="invalid">
                            {validation.errors.city}
                          </FormFeedback>
                        )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div
                        style={{
                          color: mode === "dark" ? "#fff" : "#000",
                        }}
                        className="form-group"
                      >
                        <Label className="form-label mt-2">State</Label>
                        <Input
                          name="state"
                          className="form-control"
                          placeholder="Enter State"
                          type="select"
                          onChange={e => {
                            handleStateChange(e)
                            validation.handleChange(e)
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.state || ""}
                          invalid={
                            validation.touched.state && validation.errors.state
                          }
                        >
                          <option>Select State</option>
                          {states.map(state => (
                            <option key={state.id} value={state.value}>
                              {state.label}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.country &&
                          validation.errors.country && (
                            <FormFeedback type="invalid">
                              {validation.errors.country}
                            </FormFeedback>
                          )}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="form-group">
                        <Label
                          style={{
                            color: mode === "dark" ? "#fff" : "#000",
                          }}
                          className="form-label mt-2"
                        >
                          Country
                        </Label>
                        <Input
                          name="country"
                          className="form-control"
                          placeholder="Enter Country"
                          type="select"
                          onChange={e => {
                            handleCountryChange(e)
                            validation.handleChange(e)
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.country || ""}
                          invalid={
                            validation.touched.country &&
                            validation.errors.country
                          }
                        >
                          <option>Select Country</option>
                          {countries.map(country => (
                            <option key={country.id} value={country.value}>
                              {country.label}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.country &&
                          validation.errors.country && (
                            <FormFeedback type="invalid">
                              {validation.errors.country}
                            </FormFeedback>
                          )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <Label
                          style={{
                            color: mode === "dark" ? "#fff" : "#000",
                          }}
                          className="form-label mt-2"
                        >
                          Website
                        </Label>
                        <Input
                          name="website"
                          className="form-control"
                          placeholder="Enter Website"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.website || ""}
                          invalid={
                            validation.touched.website &&
                            validation.errors.website
                          }
                        />
                        {validation.touched.website &&
                          validation.errors.website && (
                            <FormFeedback type="invalid">
                              {validation.errors.website}
                            </FormFeedback>
                          )}
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <div className="form-group">
                        <Label
                          style={{
                            color: mode === "dark" ? "#fff" : "#000",
                          }}
                          className="form-label mt-2"
                        >
                          Description
                        </Label>
                        <Input
                          name="description"
                          className="form-control"
                          placeholder="Enter Description"
                          type="textarea"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description || ""}
                          invalid={
                            validation.touched.description &&
                            validation.errors.description
                          }
                        />
                        {validation.touched.description &&
                          validation.errors.description && (
                            <FormFeedback type="invalid">
                              {validation.errors.description}
                            </FormFeedback>
                          )}
                      </div>
                    </Col>
                    {/* <Col md={6}>
                      <div className="form-group">
                        <Label className="form-label mt-2">Logo</Label>
                        <Input
                          type="file"
                          className="form-control"
                          ref={fileInputRef}
                          onChange={e => {
                            dataURItoBlob(e.target.files[0])
                          }}
                        />
                      </div>
                    </Col> */}
                  </Row>

                  <div className="text-center mt-4">
                    {loading ? (
                      <PrimaryButton
                        style={{
                          width: "120px",
                          height: "40px",
                          padding: "0px 0px",
                          fontSize: "14px",
                          backgroundColor:
                            mode === "dark" ? "#2990DF" : "#2990DF",
                        }}
                        type="submit"
                        disabled
                      >
                        <Spinner size="sm">Loading...</Spinner>
                        <span> Loading</span>
                      </PrimaryButton>
                    ) : (
                      <PrimaryButton
                        onClick={() => setConfirmModalOpen(true)} // 👈 Opens modal
                        style={{
                          width: "120px",
                          height: "40px",
                          padding: "0px 0px",
                          fontSize: "14px",
                          backgroundColor:
                            mode === "dark" ? "#2990DF" : "#2990DF",
                        }}
                        type="button" // 👈 not submit — modal confirms first
                      >
                        Save Changes
                      </PrimaryButton>
                    )}
                    <ConfirmationModal
                      isOpen={confirmModalOpen}
                      toggle={() => setConfirmModalOpen(!confirmModalOpen)}
                      mode={mode}
                      title="Confirmation"
                      messageTitle="Are you sure you want to update this organization?"
                      confirmText="Save Changes"
                      cancelText="Cancel"
                      icon={CheckCircleOutlineOutlinedIcon}
                      iconColor={mode === "dark" ? "#fff" : "#2990DF"}
                      onConfirm={() => {
                        validation.handleSubmit() // ✅ Call your save logic
                        setConfirmModalOpen(false) // ✅ Close modal after confirm
                      }}
                      onCancel={() => setConfirmModalOpen(false)} // ✅ Close on cancel
                    />
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
          {/* === Google Place ID section (inserted here) === */}
          <div
            style={{
              backgroundColor: mode === "dark" ? "#252F40" : "#fff",
              borderRadius: "20px",
            }}
          >
            <h4
              style={{
                marginLeft: "10px",
                paddingTop: "15px",
                color: mode === "dark" ? "#fff" : "#000",
              }}
              className="card-title mb-4"
            >
              Google Place Id
            </h4>
            <OrganizationPlaceId
              organizationId={organization.id}
              initialPlaceId={organization.googlePlaceId}
            />
          </div>
          <div
            style={{
              background: mode === "dark" ? "#252F40" : "#fff",
              borderRadius: "20px",
              boxShadow:
                mode === "dark"
                  ? "0px 4px 12px rgba(0, 0, 0, 0.1)"
                  : "0px 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h4
              style={{
                paddingTop: "15px",
                marginLeft: "10px",
                color: mode === "dark" ? "#fff" : "#000",
              }}
              className="card-title mb-4"
            >
              Alert Preferences
            </h4>
            <Card
              style={{
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
                boxShadow: "none",
              }}
            >
              <CardBody>
                <Form
                  className="form-horizontal"
                  onSubmit={e => {
                    e.preventDefault()
                    saveAlertPrefs()
                    return false
                  }}
                >
                  <Row>
                    <Col md={6}>
                      <div
                        className="form-group d-flex align-items-center justify-start gap-5"
                        style={{ minHeight: "56px" }}
                      >
                        <Label
                          className="form-label mt-2 mb-0"
                          style={{
                            fontWeight: 500,
                            color: mode === "dark" ? "#fff" : "#000",
                          }}
                        >
                          Individual response alerts
                        </Label>
                        <Switch
                          name="individualResponse"
                          checked={alertPrefs.individualResponse}
                          onClick={() => {
                            setAlertPrefs(prev => ({
                              ...prev,
                              individualResponse: !prev.individualResponse,
                            }))
                          }}
                          size="medium"
                          sx={{ transform: "scale(1)" }}
                        />
                      </div>
                    </Col>

                    <Col md={6}>
                      <div
                        className="form-group d-flex align-items-center justify-start gap-5"
                        style={{ minHeight: "56px" }}
                      >
                        <Label
                          className="form-label mt-2 mb-0"
                          style={{
                            fontWeight: 500,
                            color: mode === "dark" ? "#fff" : "#000",
                          }}
                        >
                          Summary Alerts
                        </Label>
                        <Switch
                          name="summary"
                          checked={alertPrefs.summary}
                          onClick={() => {
                            setAlertPrefs(prev => ({
                              ...prev,
                              summary: !prev.summary,
                            }))
                          }}
                          size="medium"
                          sx={{ transform: "scale(1)" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div
                        className="form-group d-flex align-items-center justify-start gap-5"
                        style={{ minHeight: "56px" }}
                      >
                        <Label
                          style={{
                            fontWeight: 500,
                            color: mode === "dark" ? "#fff" : "#000",
                          }}
                          className="form-label mt-2 mb-0"
                        >
                          Inactivity Alerts
                        </Label>
                        <Switch
                          name="inactivity"
                          checked={alertPrefs.inactivity}
                          onClick={() => {
                            setAlertPrefs(prev => ({
                              ...prev,
                              inactivity: !prev.inactivity,
                            }))
                          }}
                          size="medium"
                          sx={{ transform: "scale(1)" }}
                        />
                      </div>
                    </Col>

                    <Col md={6}>
                      <div
                        className="form-group d-flex align-items-center justify-start gap-5"
                        style={{ minHeight: "56px" }}
                      >
                        <Label
                          style={{
                            fontWeight: 500,
                            color: mode === "dark" ? "#fff" : "#000",
                          }}
                          className="form-label mt-2 mb-0"
                        >
                          Campaign Open Alerts
                        </Label>
                        <Switch
                          name="campaignOpen"
                          checked={alertPrefs.campaignOpen}
                          onClick={() => {
                            setAlertPrefs(prev => ({
                              ...prev,
                              campaignOpen: !prev.campaignOpen,
                            }))
                          }}
                          size="medium"
                          sx={{ transform: "scale(1)" }}
                        />
                      </div>
                    </Col>
                  </Row>

                  <div className="text-center mt-4">
                    {loading ? (
                      <PrimaryButton
                        style={{
                          backgroundColor:
                            mode === "dark" ? "#2990DF" : "#2990DF",
                          height: "40px",
                          width: "120px",
                          padding: "0px 0px",
                          fontSize: "14px",
                        }}
                        type="submit"
                        disabled
                      >
                        <Spinner size="sm">Loading...</Spinner>
                        <span> Loading</span>
                      </PrimaryButton>
                    ) : (
                      <PrimaryButton
                        onClick={() => setConfirmModalOpen(true)}
                        style={{
                          width: "120px",
                          height: "40px",
                          padding: "0px 0px",
                          fontSize: "14px",
                          backgroundColor:
                            mode === "dark" ? "#2990DF" : "#2990DF",
                        }}
                      >
                        Save Changes
                      </PrimaryButton>
                    )}
                    <ConfirmationModal
                      isOpen={confirmModalOpen}
                      toggle={() => setConfirmModalOpen(!confirmModalOpen)}
                      mode={mode}
                      title="Confirmation"
                      messageTitle="Are you sure you want to update this organization?"
                      confirmText="Save Changes"
                      cancelText="Cancel"
                      icon={CheckCircleOutlineOutlinedIcon}
                      iconColor={mode === "dark" ? "#fff" : "#2990DF"}
                      onConfirm={() => {
                        saveAlertPrefs()
                        setConfirmModalOpen(false)
                      }}
                      onCancel={() => setConfirmModalOpen(false)}
                    />
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default OrganizationForm
